import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Heading, Text, HStack, VStack, Badge, Button } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

const CaseHeaderPanel = ({ caseData, pipelineVersion, isNMA, isAdmin, children }) => {
  if (!caseData) return null;

  return (
    <HStack justifyContent="space-between" alignItems="flex-start" mb={6}>
      <VStack align="start" spacing={1}>
        {(isNMA || isAdmin) && (
          <HStack spacing={3}>
            <Badge colorScheme={pipelineVersion === 'strict' ? 'blue' : 'purple'} fontSize="md" px={2} py={1} borderRadius="md">
              Currently Displaying: {pipelineVersion === 'strict' ? 'Mode 1 (Strict)' : pipelineVersion === 'v3' ? 'Mode 3 (V3)' : 'Mode 2 (Advanced)'}
            </Badge>
            <Button
              as={RouterLink}
              to="/nma-guidelines"
              size="sm"
              colorScheme="blue"
              variant="outline"
              leftIcon={<InfoIcon />}
            >
              View Coding Guidelines
            </Button>
            <Button
              as={RouterLink}
              to={`/nma-compare-v3/${caseData.external_case_id || caseData.id}`}
              target="_blank"
              size="sm"
              colorScheme="purple"
              variant="outline"
            >
              Compare V3 ↗
            </Button>
          </HStack>
        )}
        <Text color="gray.600" mt={2}>
          <strong>Case ID:</strong> {caseData.external_case_id || caseData.id}
        </Text>
        {caseData.encounter_id && (
          <Text color="gray.600">
            <strong>Encounter ID:</strong> {caseData.encounter_id}
          </Text>
        )}
        {caseData.cpt_coding_date && (
          <Text color="gray.600" fontSize="sm">
            <strong>Last CPT Coding:</strong> {new Date(caseData.cpt_coding_date).toLocaleString()}
          </Text>
        )}
        {caseData.icd10_coding_date && (
          <Text color="gray.600" fontSize="sm">
            <strong>Last ICD-10 Coding:</strong> {new Date(caseData.icd10_coding_date).toLocaleString()}
          </Text>
        )}
      </VStack>
      {children && (
        <Box>
          {children}
        </Box>
      )}
    </HStack>
  );
};

export default CaseHeaderPanel;
